/**
 * Two small, discretionary touches (plan Part V.4) — neither affects
 * discounts, pricing, or anything transactional; both are purely playful
 * and silent unless triggered.
 *
 * 1. 5th visit within a rolling 30 days: a small crown appears on the
 *    hero seal plus a one-time toast. Tracked in localStorage only —
 *    no cookies, no server round-trip, resets naturally after 30 days
 *    of inactivity since old timestamps are pruned on every visit.
 * 2. The classic ↑↑↓↓←→←→ sequence anywhere on the homepage triggers a
 *    3-second candy-rain moment, then reverts to normal. No code, no
 *    discount — genuinely just for fun.
 */
(function () {
  var VISIT_KEY = 'bsVisitTimestamps';
  var THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  function trackVisitAndMaybeCelebrate() {
    var raw;
    try {
      raw = localStorage.getItem(VISIT_KEY);
    } catch (e) {
      return; // localStorage unavailable (private mode etc.) — skip silently
    }
    var timestamps = [];
    try {
      timestamps = raw ? JSON.parse(raw) : [];
    } catch (e) {
      timestamps = [];
    }
    var now = Date.now();
    timestamps = timestamps.filter(function (t) {
      return now - t < THIRTY_DAYS_MS;
    });
    timestamps.push(now);
    try {
      localStorage.setItem(VISIT_KEY, JSON.stringify(timestamps));
    } catch (e) {}

    if (timestamps.length === 5) {
      celebrateReturningVisitor();
    }
  }

  function celebrateReturningVisitor() {
    var seal = document.querySelector('.candy-hero-seal-wrap .candy-seal');
    if (seal) {
      var crown = document.createElement('span');
      crown.className = 'candy-seal__crown';
      crown.textContent = '👑';
      crown.setAttribute('aria-hidden', 'true');
      seal.appendChild(crown);
    }
    showToast('Schön, dass du wieder da bist. 🍬');
  }

  function showToast(message) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var toast = document.createElement('div');
    toast.className = 'candy-easter-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.remove();
      }, 400);
    }, 4000);
  }

  // --- Konami-style sequence: candy rain -----------------------------------
  var SEQUENCE = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight'];
  var progress = 0;

  function triggerCandyRain() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var emojis = ['🍬', '🍭', '🍫', '🍡', '🧁'];
    var container = document.createElement('div');
    container.className = 'candy-rain';
    container.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('span');
      piece.className = 'candy-rain__piece';
      piece.textContent = emojis[Math.floor(Math.random() * emojis.length)];
      piece.style.left = Math.random() * 100 + 'vw';
      piece.style.animationDelay = Math.random() * 0.6 + 's';
      piece.style.animationDuration = 2 + Math.random() * 1.5 + 's';
      container.appendChild(piece);
    }
    document.body.appendChild(container);
    setTimeout(function () {
      container.remove();
    }, 3200);
  }

  document.addEventListener('keydown', function (event) {
    var expected = SEQUENCE[progress];
    if (event.key === expected) {
      progress++;
      if (progress === SEQUENCE.length) {
        progress = 0;
        triggerCandyRain();
      }
    } else {
      progress = event.key === SEQUENCE[0] ? 1 : 0;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackVisitAndMaybeCelebrate);
  } else {
    trackVisitAndMaybeCelebrate();
  }
})();
